import { CheckCircleIcon } from '@chakra-ui/icons';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React from 'react';

const SuccessModal = ({ isOpen, onClose }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay data-testid="overlay" />
      <ModalContent>
        <ModalHeader></ModalHeader>
        <ModalCloseButton data-testid="close" />
        <ModalBody textAlign="center">
          <CheckCircleIcon color="colors.primary" width="40px" height="40px" />
          <Text
            marginTop="12px"
            fontWeight="700"
            fontSize="22px"
            lineHeight="33px"
          >
            Success!
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button
            backgroundColor="colors.primary"
            color="colors.white"
            onClick={onClose}
            width="100%"
          >
            Go back to dashboard
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SuccessModal;
